import css from 'styled-jsx/css';

const styles = css.global`.usage {
  margin-top: 40px;
  box-sizing: border-box;
}

.usage.hidden {
  display: none !important;
}

.usage .usage-title {
  font-family: 'SantanderHeadline';
  font-weight: 400;
  font-size: 32px;
  line-height: 42px;
  letter-spacing: 0%;
  color: #222;
  max-width: 288px;
}

.usage .usage-subtitle {
  font-family: 'SantanderMicroText';
  font-weight: 400;
  font-size: 18px;
  line-height: 28px;
  letter-spacing: 0%;
  color: #222222;
  margin: 32px 0;
}

.usage .button-row {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 40px;
  margin: 40px 0;
}

.usage .text-rooftype {
  font-family: 'SantanderMicroText';
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
  letter-spacing: 0%;
  margin-bottom: 16px;
}

.usage .form-render {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  gap: 32px;
  max-width: 520px;
}

.usage .button-row-form {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 16px;
  padding-top: 24px;
  margin: 88px 0 0;
  border-top: 1px solid #cccccc;
}

.usage .field-wrapper {
  position: relative;
}

.usage #cta-nao-sei-cep {
  font-family: 'SantanderText';
  font-weight: 400;
  font-style: Regular;
  font-size: 18px;
  line-height: 28px;
  letter-spacing: 0%;
  text-align: right;
  text-decoration: underline;
  text-decoration-style: solid;
  text-decoration-thickness: 0%;

  color: #cc0000;

  cursor: pointer;
  text-align: right;
  margin-left: auto;
  display: block;
  box-sizing: border-box;
  width: fit-content;
}

.usage .form-render .postal-code .text-field__helper.error {
  position: absolute;
  margin: 0;
  bottom: -6px;
  left: 14px;
  transform: translateY(100%);
}

#chk-sem-numero {
  margin-top: 26px;
}

.usage .cost-info {
  border: 1px solid #cccccc;
  border-radius: 6px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 32px;
  gap: 24px;
  box-sizing: border-box;
  margin-top: 40px;
  max-width: 520px;
}

.usage .cost-info p,
.usage .cost-info b {
  font-family: 'SantanderText';
  font-weight: 400;
  font-size: 20px;
  line-height: 120%;
  letter-spacing: 0px;
  color: #444;
  margin: 0;
}

.usage .cost-info b {
  display: block;
  margin-top: 8px;
  font-weight: 600;
  font-size: 24px;
}

.usage .range-select {
  margin-top: 56px;
  max-width: 808px;
}

@media (min-width: 992px) {
  .usage .usage-title {
    font-size: 40px;
    line-height: 60px;
    max-width: unset;
  }

  .usage .button-row-form {
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
  }

  .usage .button-row-form button:nth-child(1) {
    max-width: 120px;
  }
  .usage .button-row-form button:nth-child(2) {
    max-width: 228px;
  }
}
`;

export default styles;